export const stage = ['stage'];
